// export const EMAIL_REGEXP = Object.freeze(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/)
export const EMAIL_REGEXP = Object.freeze(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)

export const DECIMALS_REGEXP = Object.freeze(/^[0-9]+([,.][0-9]+)?$/)
